<!--
Author:
Create Time: 2019-07-26 14:33:55
Description:
-->
<template>
  <div class="com-merchant-table-select">
    <tableSelect
      ref="tableSelect"
      :value="value"
      @input="handleInput"
      :data="pageData.list"
      :multiple="false"
      width="400"
      v-bind="tableConfig"
      :pageInfo="pageData"
      @current-page-change="handleCurrentPageChange"
      @filter-change="handleFilterChange"
      :readonly="readonly"
      :disabled="disabled"
      :clearable="clearable"
    ></tableSelect>
  </div>
</template>

<script>
import tableSelect from "../tableSelect/tableSelect.vue";
import { debounce } from "../../utils/rate-limit";

export default {
  name: "supplierTableSelect",
  components: {
    tableSelect
  },
  props: {
    value: {
      type: String,
      default: () => ""
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    additionSearchCondition: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      condition: {
        supplierName: ""
        // status: 1 // 使用状态 1: 启用, 0: 禁用
      },
      pageData: {
        list: [],
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      },
      tableConfig: {
        idProp: "id",
        codeProp: "supplierCode",
        codeLabel: "供应商编码",
        nameProp: "supplierName",
        nameLabel: "供应商名称"
      }
    };
  },
  computed: {
    query4Filter() {
      return debounce(1000, this.query);
    }
  },
  watch: {
    value(val) {
      this.updateSelection();
    },
    additionSearchCondition() {
      this.query().then(() => this.updateSelection());
    },
  },
  methods: {
    query() {
      return this.$http
        .post(this.api.supplierdocQueryByCondition, {
          condition: {
            ...this.condition,
            ...this.additionSearchCondition
          },
          number: this.pageData.currentPage,
          size: this.pageData.pageSize
        })
        .then(res => {
          if (res.data.code === "200") {
            this.pageData.list = res.data.body.records;
            this.pageData.totalCount = res.data.body.total;
            this.pageData.totalPage = res.data.body.pages;
          }
        });
    },
    handleCurrentPageChange(currentPage) {
      this.pageData.currentPage = currentPage;
      this.query();
    },
    handleFilterChange(filter) {
      this.condition.supplierName = filter;
      this.query4Filter();
    },
    handleInput(val) {
      this.$emit(
        "input",
        val,
        this.pageData.list.find(
          item => item && item[this.tableConfig.idProp] === val
        )
      );
    },
    setSelection(selection) {
      this.$refs.tableSelect.setSelection(selection);
    },
    updateSelection() {
      let val = this.value;
      if (val) {
        const item = this.pageData.list.find(
          item => item && item[this.tableConfig.idProp] === val
        );
        this.setSelection(item ? [item] : []);
      } else {
        this.setSelection([]);
      }
    },
  },
  mounted() {
    this.query().then(() => this.updateSelection());
  }
};
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/components/supplier/supplierTableSelect.vue